<template>
  <div>
    <home-welcome-sec
      @searchResultChange="searchResultReset"
      :searchQuery="$route.query.q"
      class="mb-4"
    ></home-welcome-sec>
    <div class="main-search-results-sec">
      <div class="container">
        <!--                {{q_response}}-->
        <div v-if="isSarchReseeted">
          <h1 class="page-title">
            Резултати претраге за појам
            <b class="search-query">"{{ queryWord }}"</b>
          </h1>
        </div>
        <div class="spacer30"></div>

        <div v-if="q_response" class="search-results">
          <div v-if="q_response.resultMap.REG">
            <h3 class="search-sec__title can_open">
              Регистар и текстови важећих прописа и других аката
            </h3>
            <div class="row">
              <div class="col-12">
                <div class="search-sub-sec can_open">
                  <!--    can_open    -->
                  <div v-if="q_response" class="search-sub-sec__body can_open">
                    <div
                      v-for="(news, index) in q_response.resultMap.REG"
                      v-bind:key="index"
                      class="search-result__item "
                    >
                      <router-link
                        target="_blank"
                        v-if="news.uuid !== null && news.uuid !== ''"
                        :to="{ path: 'viewAct/' + news.uuid }"
                      >
                        <span class="text">{{ news.title }}</span>
                      </router-link>
                      <router-link
                        v-else
                        :to="'viewPdf/' + news.id"
                        target="_blank"
                      >
                        {{ news.title }}
                      </router-link>
                    </div>
                  </div>
                  <div
                    v-if="q_response.resultMap.REG_total"
                    class="search-sub-sec__footer"
                  >
                    <!--   http://pravno-informacioni-sistem.rs/SlGlasnikPortal/reg/advancedSearch?q=xxxxxx-->
                    <router-link
                      class="search-sub-sec__more-link d-flex align-items-center justify-content-between"
                      :to="{
                        path: '/reg-search',
                        query: { q: $route.query.q },
                      }"
                    >
                      <span class="text">
                        Приказано {{ q_response.resultMap.REG.length }} од
                        {{ q_response.resultMap.REG_total }} резултата. Види све
                        резултате претраге
                      </span>
                      <div class="search-sub-sec__read-more">
                        <span class="icon-chevron-right"></span>
                        <span class="icon-chevron-right"></span>
                        <span class="icon-chevron-right"></span>
                      </div>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- ********************************************************************************************-->
          <div
            v-if="
              q_response.resultMap.NP ||
                q_response.resultMap.PG2010 ||
                q_response.resultMap.MUTG
            "
          >
            <h3
              class="search-sec__title"
              :class="{
                can_open:
                  canOpen('NP') === 'can_open' ||
                  canOpen('PG2010') === 'can_open' ||
                  canOpen('MUTG') === 'can_open',
              }"
            >
              Службени гласник Републике Србије
            </h3>
            <div class="row">
              <div v-if="q_response.resultMap.NP" class="col-md-6">
                <div class="search-sub-sec" :class="canOpen('NP')">
                  <div class="search-sub-sec__header">
                    <h3 class="search-sub-sec__title">Службени гласник РС</h3>
                  </div>
                  <div class="search-sub-sec__body">
                    <div
                      v-for="(news, index) in q_response.resultMap.NP"
                      v-bind:key="index"
                      class="search-result__item "
                    >
                      <div v-if="news.url">
                        <router-link
                          target="_blank"
                          v-if="canOpen('NP') === 'can_open'"
                          :to="{ path: '/slglrs/viewAct/' + news.id }"
                          >{{ news.name }}</router-link
                        >
                        <a
                          v-if="canOpen('NP') === 'not_logged_in'"
                          v-b-modal.login-modal
                          href="#"
                        >
                          {{ news.name }}
                        </a>
                        <a
                          v-if="canOpen('NP') === 'role_not_allowed'"
                          href="#"
                          @click.stop.prevent="role_not_allowed()"
                        >
                          {{ news.name }}
                        </a>
                      </div>
                      <div v-else>
                        <a
                          v-if="canOpen('NP') === 'can_open'"
                          target="_blank"
                          :href="
                            baseSLGLApiUrl + 'Prins/GetPdfById?id=' + news.ogId
                          "
                        >
                          {{ news.name }}
                        </a>
                        <a
                          href="#"
                          v-if="canOpen('NP') === 'not_logged_in'"
                          v-b-modal.login-modal
                        >
                          {{ news.name }}
                        </a>
                        <a
                          v-if="canOpen('NP') === 'role_not_allowed'"
                          href="#"
                          @click.stop.prevent="role_not_allowed()"
                        >
                          {{ news.name }}
                        </a>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="q_response.resultMap.SGARHSTARO_total"
                    class="search-sub-sec__footer"
                  >
                    <router-link
                      class="search-sub-sec__more-link d-flex align-items-center justify-content-between"
                      :to="{
                        path: '/slglrsNP-search',
                        query: { q: $route.query.q },
                      }"
                    >
                      <span class="text">
                        Приказано
                        {{ q_response.resultMap.SGARHSTARO.length }} од
                        {{ q_response.resultMap.NP_total }} резултата. Види све
                        резултате претраге
                      </span>
                      <div class="search-sub-sec__read-more">
                        <span class="icon-chevron-right"></span>
                        <span class="icon-chevron-right"></span>
                        <span class="icon-chevron-right"></span>
                      </div>
                    </router-link>
                  </div>
                </div>
              </div>

              <div v-if="q_response.resultMap.PG2010" class="col-md-6">
                <div class="search-sub-sec" :class="canOpen('PG2010')">
                  <div class="search-sub-sec__header">
                    <h3 class="search-sub-sec__title">
                      Службени гласник РС Просветни гласник
                    </h3>
                  </div>
                  <div class="search-sub-sec__body">
                    <div
                      v-for="(news, index) in q_response.resultMap.PG2010"
                      v-bind:key="index"
                      class="search-result__item "
                    >
                      <div v-if="news.url">
                        <router-link
                          target="_blank"
                          v-if="canOpen('PG2010') === 'can_open'"
                          :to="{ path: '/slglrs/viewAct/' + news.id }"
                          >{{ news.name }}</router-link
                        >
                        <a
                          v-if="canOpen('PG2010') === 'not_logged_in'"
                          v-b-modal.login-modal
                          href="#"
                        >
                          {{ news.name }}
                        </a>
                        <a
                          v-if="canOpen('PG2010') === 'role_not_allowed'"
                          href="#"
                          @click.stop.prevent="role_not_allowed()"
                        >
                          {{ news.name }}
                        </a>
                      </div>
                      <div v-else>
                        <a
                          v-if="canOpen('PG2010') === 'can_open'"
                          target="_blank"
                          :href="
                            baseSLGLApiUrl + 'Prins/GetPdfById?id=' + news.ogId
                          "
                        >
                          {{ news.name }}
                        </a>
                        <a
                          v-if="canOpen('PG2010') === 'not_logged_in'"
                          v-b-modal.login-modal
                          href="#"
                        >
                          {{ news.name }}
                        </a>
                        <a
                          v-if="canOpen('PG2010') === 'role_not_allowed'"
                          href="#"
                          @click.stop.prevent="role_not_allowed()"
                        >
                          {{ news.name }}
                        </a>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="q_response.resultMap.PG2010_total"
                    class="search-sub-sec__footer"
                  >
                    <router-link
                      class="search-sub-sec__more-link d-flex align-items-center justify-content-between"
                      :to="{
                        path: '/slglrsPG2010-search',
                        query: { q: $route.query.q },
                      }"
                    >
                      <span class="text">
                        Приказано {{ q_response.resultMap.PG2010.length }} од
                        {{ q_response.resultMap.PG2010_total }} резултата. Види
                        све резултате претраге
                      </span>
                      <div class="search-sub-sec__read-more">
                        <span class="icon-chevron-right"></span>
                        <span class="icon-chevron-right"></span>
                        <span class="icon-chevron-right"></span>
                      </div>
                    </router-link>
                  </div>
                </div>
              </div>
              <div v-if="q_response.resultMap.MUTG" class="col-md-6">
                <div class="search-sub-sec" :class="canOpen('MUTG')">
                  <div class="search-sub-sec__header">
                    <h3 class="search-sub-sec__title">
                      Службени гласник РС Међународни уговори
                    </h3>
                  </div>
                  <div class="search-sub-sec__body">
                    <div
                      v-for="(news, index) in q_response.resultMap.MUTG"
                      v-bind:key="index"
                      class="search-result__item "
                    >
                      <!--                                            <pre>  {{news}}   </pre>-->
                      <div v-if="news.url">
                        <router-link
                          target="_blank"
                          v-if="canOpen('MUTG') === 'can_open'"
                          :to="{ path: '/slglrs/viewAct/' + news.id }"
                          >{{ news.name }}</router-link
                        >
                        <a
                          v-if="canOpen('MUTG') === 'not_logged_in'"
                          v-b-modal.login-modal
                          href="#"
                        >
                          {{ news.name }}
                        </a>
                        <a
                          v-if="canOpen('MUTG') === 'role_not_allowed'"
                          href="#"
                          @click.stop.prevent="role_not_allowed()"
                        >
                          {{ news.name }}
                        </a>
                      </div>
                      <div v-else>
                        <a
                          v-if="canOpen('MUTG') === 'can_open'"
                          target="_blank"
                          :href="
                            baseSLGLApiUrl + 'Prins/GetPdfById?id=' + news.ogId
                          "
                        >
                          <!--                                                        :to="'/news/viewActPfd/'+ 'slglrs' + '/'+news.url"-->
                          {{ news.name }}
                        </a>
                        <a
                          v-if="canOpen('MUTG') === 'not_logged_in'"
                          v-b-modal.login-modal
                          href="#"
                        >
                          {{ news.name }}
                        </a>
                        <a
                          v-if="canOpen('MUTG') === 'role_not_allowed'"
                          href="#"
                          @click.stop.prevent="role_not_allowed()"
                        >
                          {{ news.name }}
                        </a>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="q_response.resultMap.MUTG_total"
                    class="search-sub-sec__footer"
                  >
                    <router-link
                      class="search-sub-sec__more-link d-flex align-items-center justify-content-between"
                      :to="{
                        path: '/slglrsMUTG-search',
                        query: { q: $route.query.q },
                      }"
                    >
                      <span class="text">
                        Приказано {{ q_response.resultMap.MUTG.length }} од
                        {{ q_response.resultMap.MUTG_total }} резултата. Види
                        све резултате претраге
                      </span>
                      <div class="search-sub-sec__read-more">
                        <span class="icon-chevron-right"></span>
                        <span class="icon-chevron-right"></span>
                        <span class="icon-chevron-right"></span>
                      </div>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="
              q_response.resultMap.SLARHSTARO ||
                q_response.resultMap.PGARHSTARO ||
                q_response.resultMap.SGARHSTARO ||
                q_response.resultMap.MUARHSTARO
            "
          >
            <h3
              class="search-sec__title"
              :class="{
                can_open:
                  canOpen('SLARHSTARO') === 'can_open' ||
                  canOpen('PGARHSTARO') === 'can_open' ||
                  canOpen('SLARHSTARO') === 'can_open' ||
                  canOpen('MUARHSTARO') === 'can_open',
              }"
            >
              Архива службених гласила
            </h3>
            <div class="row">
              <div v-if="q_response.resultMap.SGARHSTARO" class="col-md-6">
                <div class="search-sub-sec" :class="canOpen('SLARHSTARO')">
                  <div class="search-sub-sec__header">
                    <h3 class="search-sub-sec__title">
                      Архива Службеног гласника
                    </h3>
                  </div>
                  <div class="search-sub-sec__body">
                    <div
                      v-for="(news, index) in q_response.resultMap.SGARHSTARO"
                      v-bind:key="index"
                      class="search-result__item "
                    >
                      <!--                                            <pre>  {{news}}   </pre>-->
                      <div v-if="news.url">
                        <router-link
                          target="_blank"
                          v-if="canOpen('SGARHSTARO') === 'can_open'"
                          :to="{ path: '/slglrs/viewAct/' + news.id }"
                          >{{ news.name }}</router-link
                        >
                        <a
                          v-if="canOpen('SGARHSTARO') === 'not_logged_in'"
                          v-b-modal.login-modal
                          href="#"
                        >
                          {{ news.name }}
                        </a>
                        <a
                          v-if="canOpen('SGARHSTARO') === 'role_not_allowed'"
                          href="#"
                          @click.stop.prevent="role_not_allowed()"
                        >
                          {{ news.name }}
                        </a>
                      </div>
                      <div v-else>
                        <a
                          v-if="canOpen('SGARHSTARO') === 'can_open'"
                          target="_blank"
                          :href="
                            baseSLGLApiUrl + 'Prins/GetPdfById?id=' + news.ogId
                          "
                        >
                          <!--                                                        :to="'/news/viewActPfd/'+ 'slglrs' + '/'+news.url"-->
                          {{ news.name }}
                        </a>
                        <a
                          v-if="canOpen('SGARHSTARO') === 'not_logged_in'"
                          v-b-modal.login-modal
                          href="#"
                        >
                          {{ news.name }}
                        </a>
                        <a
                          v-if="canOpen('SGARHSTARO') === 'role_not_allowed'"
                          href="#"
                          @click.stop.prevent="role_not_allowed()"
                        >
                          {{ news.name }}
                        </a>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="q_response.resultMap.SGARHSTARO_total"
                    class="search-sub-sec__footer"
                  >
                    <router-link
                      class="search-sub-sec__more-link d-flex align-items-center justify-content-between"
                      :to="{
                        path: '/arhslgl-sgarh-search',
                        query: { q: $route.query.q },
                      }"
                    >
                      <span class="text">
                        Приказано
                        {{ q_response.resultMap.SGARHSTARO.length }} од
                        {{ q_response.resultMap.SGARHSTARO_total }} резултата.
                        Види све резултате претраге
                      </span>
                      <div class="search-sub-sec__read-more">
                        <span class="icon-chevron-right"></span>
                        <span class="icon-chevron-right"></span>
                        <span class="icon-chevron-right"></span>
                      </div>
                    </router-link>
                  </div>
                </div>
              </div>
              <div v-if="q_response.resultMap.PGARHSTARO" class="col-md-6">
                <div class="search-sub-sec" :class="canOpen('PGARHSTARO')">
                  <div class="search-sub-sec__header">
                    <h3 class="search-sub-sec__title">
                      Архива Просветног гласника
                    </h3>
                  </div>
                  <div class="search-sub-sec__body">
                    <div
                      v-for="(news, index) in q_response.resultMap.PGARHSTARO"
                      v-bind:key="index"
                      class="search-result__item "
                    >
                      <div v-if="news.url">
                        <router-link
                          target="_blank"
                          v-if="canOpen('PGARHSTARO') === 'can_open'"
                          :to="{ path: '/slglrs/viewAct/' + news.id }"
                          >{{ news.name }}</router-link
                        >
                        <a
                          v-if="canOpen('PGARHSTARO') === 'not_logged_in'"
                          v-b-modal.login-modal
                          href="#"
                        >
                          {{ news.name }}
                        </a>
                        <a
                          v-if="canOpen('PGARHSTARO') === 'role_not_allowed'"
                          href="#"
                          @click.stop.prevent="role_not_allowed()"
                        >
                          {{ news.name }}
                        </a>
                      </div>
                      <div v-else>
                        <a
                          v-if="canOpen('PGARHSTARO') === 'can_open'"
                          target="_blank"
                          :href="
                            baseSLGLApiUrl + 'Prins/GetPdfById?id=' + news.ogId
                          "
                        >
                          <!--                                                        :to="'/news/viewActPfd/'+ 'slglrs' + '/'+news.url"-->
                          {{ news.name }}
                        </a>
                        <router-link
                          target="_blank"
                          v-if="canOpen('PGARHSTARO') === 'can_open'"
                          :to="{ path: '/slglrs/viewAct/' + news.id }"
                          >{{ news.name }}</router-link
                        >
                        <a
                          v-if="canOpen('PGARHSTARO') === 'not_logged_in'"
                          v-b-modal.login-modal
                          href="#"
                        >
                          {{ news.name }}
                        </a>
                        <a
                          v-if="canOpen('PGARHSTARO') === 'role_not_allowed'"
                          href="#"
                          @click.stop.prevent="role_not_allowed()"
                        >
                          {{ news.name }}
                        </a>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="q_response.resultMap.PGARHSTARO_total"
                    class="search-sub-sec__footer"
                  >
                    <router-link
                      class="search-sub-sec__more-link d-flex align-items-center justify-content-between"
                      :to="{
                        path: '/arhslgl-pgarh-search',
                        query: { q: $route.query.q },
                      }"
                    >
                      <span class="text">
                        Приказано
                        {{ q_response.resultMap.PGARHSTARO.length }} од
                        {{ q_response.resultMap.PGARHSTARO_total }} резултата.
                        Види све резултате претраге
                      </span>
                      <div class="search-sub-sec__read-more">
                        <span class="icon-chevron-right"></span>
                        <span class="icon-chevron-right"></span>
                        <span class="icon-chevron-right"></span>
                      </div>
                    </router-link>
                  </div>
                </div>
              </div>
              <div v-if="q_response.resultMap.SLARHSTARO" class="col-md-6">
                <div class="search-sub-sec" :class="canOpen('SLARHSTARO')">
                  <div class="search-sub-sec__header">
                    <h3 class="search-sub-sec__title">
                      Архива Службеног листа
                    </h3>
                  </div>
                  <div class="search-sub-sec__body">
                    <div
                      v-for="(news, index) in q_response.resultMap.SLARHSTARO"
                      v-bind:key="index"
                      class="search-result__item "
                    >
                      <!--                                            <pre>  {{news}}   </pre>-->
                      <div v-if="news.url">
                        <router-link
                          target="_blank"
                          v-if="canOpen('SLARHSTARO') === 'can_open'"
                          :to="{ path: '/slglrs/viewAct/' + news.id }"
                          >{{ news.name }}</router-link
                        >
                        <a
                          v-if="canOpen('SLARHSTARO') === 'not_logged_in'"
                          v-b-modal.login-modal
                          href="#"
                          @click.stop.prevent
                        >
                          {{ news.name }}
                        </a>
                        <a
                          v-if="canOpen('SLARHSTARO') === 'role_not_allowed'"
                          href="#"
                          @click.stop.prevent="role_not_allowed()"
                        >
                          {{ news.name }}
                        </a>
                      </div>
                      <div v-else>
                        <a
                          v-if="canOpen('SLARHSTARO') === 'can_open'"
                          target="_blank"
                          :href="
                            baseSLGLApiUrl + 'Prins/GetPdfById?id=' + news.ogId
                          "
                        >
                          <!--                                                        :to="'/news/viewActPfd/'+ 'slglrs' + '/'+news.url"-->
                          {{ news.name }}
                        </a>
                        <a
                          v-if="canOpen('SLARHSTARO') === 'not_logged_in'"
                          v-b-modal.login-modal
                          href="#"
                        >
                          {{ news.name }}
                        </a>
                        <a
                          v-if="canOpen('SLARHSTARO') === 'role_not_allowed'"
                          href="#"
                          @click.stop.prevent="role_not_allowed()"
                        >
                          {{ news.name }}
                        </a>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="q_response.resultMap.SLARHSTARO_total"
                    class="search-sub-sec__footer"
                  >
                    <router-link
                      class="search-sub-sec__more-link d-flex align-items-center justify-content-between"
                      :to="{
                        path: '/arhslgl-slarh-search',
                        query: { q: $route.query.q },
                      }"
                    >
                      <span class="text">
                        Приказано
                        {{ q_response.resultMap.SLARHSTARO.length }} од
                        {{ q_response.resultMap.SLARHSTARO_total }} резултата.
                        Види све резултате претраге
                      </span>
                      <div class="search-sub-sec__read-more">
                        <span class="icon-chevron-right"></span>
                        <span class="icon-chevron-right"></span>
                        <span class="icon-chevron-right"></span>
                      </div>
                    </router-link>
                  </div>
                </div>
              </div>
              <div v-if="q_response.resultMap.MUARHSTARO" class="col-md-6">
                <div class="search-sub-sec" :class="canOpen('MUARHSTARO')">
                  <div class="search-sub-sec__header">
                    <h3 class="search-sub-sec__title">
                      Архива ратификованих међународних уговора и других аката
                    </h3>
                  </div>
                  <div class="search-sub-sec__body">
                    <div
                      v-for="(news, index) in q_response.resultMap.MUARHSTARO"
                      v-bind:key="index"
                      class="search-result__item "
                    >
                      <div v-if="news.url">
                        <router-link
                          target="_blank"
                          v-if="canOpen('MUARHSTARO') === 'can_open'"
                          :to="{ path: '/slglrs/viewAct/' + news.id }"
                          >{{ news.name }}</router-link
                        >
                        <a
                          v-if="canOpen('MUARHSTARO') === 'not_logged_in'"
                          v-b-modal.login-modal
                          href="#"
                          @click.stop.prevent
                        >
                          {{ news.name }}
                        </a>
                        <a
                          v-if="canOpen('MUARHSTARO') === 'role_not_allowed'"
                          href="#"
                          @click.stop.prevent="role_not_allowed()"
                        >
                          {{ news.name }}
                        </a>
                      </div>
                      <div v-else>
                        <a
                          v-if="canOpen('MUARHSTARO') === 'can_open'"
                          target="_blank"
                          :href="
                            baseSLGLApiUrl + 'Prins/GetPdfById?id=' + news.ogId
                          "
                        >
                          <!--   :to="'/news/viewActPfd/'+ 'slglrs' + '/'+news.url"-->
                          {{ news.name }}
                        </a>
                        <a
                          v-if="canOpen('MUARHSTARO') === 'not_logged_in'"
                          v-b-modal.login-modal
                          href="#"
                          @click.stop.prevent
                        >
                          {{ news.name }}
                        </a>
                        <a
                          v-if="canOpen('MUARHSTARO') === 'role_not_allowed'"
                          href="#"
                          @click.stop.prevent="role_not_allowed()"
                        >
                          {{ news.name }}
                        </a>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="q_response.resultMap.MUARHSTARO_total"
                    class="search-sub-sec__footer"
                  >
                    <router-link
                      class="search-sub-sec__more-link d-flex align-items-center justify-content-between"
                      :to="{
                        path: '/arhslgl-muarh-search',
                        query: { q: $route.query.q },
                      }"
                    >
                      <span class="text">
                        Приказано
                        {{ q_response.resultMap.MUARHSTARO.length }} од
                        {{ q_response.resultMap.MUARHSTARO_total }} резултата.
                        Види све резултате претраге
                      </span>
                      <div class="search-sub-sec__read-more">
                        <span class="icon-chevron-right"></span>
                        <span class="icon-chevron-right"></span>
                        <span class="icon-chevron-right"></span>
                      </div>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- ********************************************************************************************-->

          <div v-if="q_response.resultMap.SUPA">
            <h3
              class="search-sec__title"
              :class="{ can_open: canOpen('SP') === 'can_open' }"
            >
              Судска пракса
            </h3>
            <div class="row">
              <div class="col-md-12">
                <div class="search-sub-sec" :class="canOpen('SP')">
                  <div class="search-sub-sec__body">
                    <div
                      v-for="(news, index) in q_response.resultMap.SUPA"
                      v-bind:key="index"
                      class="search-result__item "
                    >
                      <div v-if="news.url">
                        <a
                          v-if="canOpen('SP') === 'can_open'"
                          target="_blank"
                          :href="baseApiUrl + 'api/supa/pdf?id=' + news.url"
                        >
                          <!--    :to="'/news/viewActPfd/'+ 'supa' + '/'+news.url"-->
                          {{ news.name }}
                        </a>
                        <a
                          v-if="canOpen('SP') === 'not_logged_in'"
                          v-b-modal.login-modal
                          href="#"
                          @click.stop.prevent
                        >
                          {{ news.name }}
                        </a>
                        <a
                          v-if="canOpen('SP') === 'role_not_allowed'"
                          href="#"
                          @click.stop.prevent="role_not_allowed()"
                        >
                          {{ news.name }}
                        </a>
                      </div>
                      <div v-else>
                        <router-link
                          target="_blank"
                          v-if="canOpen('SP') === 'can_open'"
                          :to="{ path: '/supa/viewAct/' + news.id }"
                          >{{ news.name }}</router-link
                        >
                        <a
                          v-if="canOpen('SP') === 'not_logged_in'"
                          v-b-modal.login-modal
                          href="#"
                          @click.stop.prevent
                        >
                          {{ news.name }}
                        </a>
                        <a
                          v-if="canOpen('SP') === 'role_not_allowed'"
                          href="#"
                          @click.stop.prevent="role_not_allowed()"
                        >
                          {{ news.name }}
                        </a>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="q_response.resultMap.SUPA_total"
                    class="search-sub-sec__footer"
                  >
                    <router-link
                      class="search-sub-sec__more-link d-flex align-items-center justify-content-between"
                      :to="{
                        path: '/supa-standardSearch',
                        query: { q: $route.query.q },
                      }"
                    >
                      <span class="text">
                        Приказано {{ q_response.resultMap.SUPA.length }} од
                        {{ q_response.resultMap.SUPA_total }} резултата. Види
                        све резултате претраге
                      </span>
                      <div class="search-sub-sec__read-more">
                        <span class="icon-chevron-right"></span>
                        <span class="icon-chevron-right"></span>
                        <span class="icon-chevron-right"></span>
                      </div>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- ********************************************************************************************-->
          <div v-if="q_response.resultMap.MML">
            <h3
              class="search-sec__title"
              :class="{ can_open: canOpen('LSD') === 'can_open' }"
            >
              Мишљења, модели, литература
            </h3>
            <div class="row">
              <div class="col-md-12">
                <div class="search-sub-sec" :class="canOpen('LSD')">
                  <div class="search-sub-sec__body">
                    <div
                      v-for="(news, index) in q_response.resultMap.MML"
                      v-bind:key="index"
                      class="search-result__item "
                    >
                      <div v-if="news.url">
                        <a
                          v-if="canOpen('LSD') === 'can_open'"
                          target="_blank"
                          :href="baseApiUrl + 'api/mml/pdf?id=' + news.url"
                        >
                          <!--                                                             :to="'/news/viewActPfd/'+ 'mml' + '/'+news.url"-->
                          {{ news.closerDesignation }}
                        </a>
                        <a
                          v-if="canOpen('LSD') === 'not_logged_in'"
                          v-b-modal.login-modal
                          href="#"
                          @click.stop.prevent
                        >
                          {{ news.closerDesignation }}
                        </a>
                        <a
                          v-if="canOpen('LSD') === 'role_not_allowed'"
                          href="#"
                          @click.stop.prevent="role_not_allowed()"
                        >
                          {{ news.closerDesignation }}
                        </a>
                      </div>
                      <div v-else>
                        <router-link
                          target="_blank"
                          v-if="canOpen('LSD') === 'can_open'"
                          :to="{ path: '/mml/viewAct/' + news.id }"
                          >{{ news.closerDesignation }}</router-link
                        >
                        <a
                          v-if="canOpen('LSD') === 'not_logged_in'"
                          v-b-modal.login-modal
                          href="#"
                          @click.stop.prevent
                        >
                          {{ news.closerDesignation }}
                        </a>
                        <a
                          v-if="canOpen('LSD') === 'role_not_allowed'"
                          href="#"
                          @click.stop.prevent="role_not_allowed()"
                        >
                          {{ news.closerDesignation }}
                        </a>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="q_response.resultMap.MML_total"
                    class="search-sub-sec__footer"
                  >
                    <router-link
                      class="search-sub-sec__more-link d-flex align-items-center justify-content-between"
                      :to="{
                        path: '/mml-standard-search',
                        query: { q: $route.query.q },
                      }"
                    >
                      <span class="text">
                        Приказано {{ q_response.resultMap.MML.length }} од
                        {{ q_response.resultMap.MML_total }} резултата. Види све
                        резултате претраге
                      </span>
                      <div class="search-sub-sec__read-more">
                        <span class="icon-chevron-right"></span>
                        <span class="icon-chevron-right"></span>
                        <span class="icon-chevron-right"></span>
                      </div>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- ********************************************************************************************-->
          <div
            v-if="
              q_response.resultMap.PP_ESZLJP ||
                q_response.resultMap.PP_KD ||
                q_response.resultMap.Regulations
            "
          >
            <h3
              class="search-sec__title"
              :class="{
                can_open:
                  canOpen('WPP_ESZLJP_GUIDE') === 'can_open' ||
                  canOpen('WPP_KD') === 'can_open',
              }"
            >
              Посебни програмски пакети
            </h3>
            <div class="row">
              <div v-if="q_response.resultMap.PP_ESZLJP" class="col-6">
                <div
                  class="search-sub-sec"
                  :class="canOpen('WPP_ESZLJP_GUIDE')"
                >
                  <div class="search-sub-sec__header">
                    <h3
                      class="search-sub-sec__title"
                      :class="{
                        can_open: canOpen('WPP_ESZLJP_GUIDE') === 'can_open',
                      }"
                    >
                      Водич кроз пресуде Европског суда за људска права
                    </h3>
                  </div>
                  <div class="search-sub-sec__body">
                    <div
                      v-for="(news, index) in q_response.resultMap.PP_ESZLJP"
                      v-bind:key="index"
                      class="search-result__item "
                    >
                      <router-link
                        v-if="
                          canOpen('WPP_ESZLJP_GUIDE') === 'can_open' &&
                            news.act_type === 'REG' &&
                            news.has_html === 'False'
                        "
                        :to="
                          '/pppViewPdf/' +
                            news.reg_db_id +
                            '?doctype=' +
                            news.act_type
                        "
                        target="_blank"
                      >
                        {{ news.title }}
                      </router-link>
                      <router-link
                        v-else-if="
                          canOpen('WPP_ESZLJP_GUIDE') === 'can_open' &&
                            news.act_type === 'SLGLRS' &&
                            news.has_html === 'False'
                        "
                        :to="
                          '/pppViewPdf/' +
                            news.guid_pdf_url +
                            '?doctype=' +
                            news.act_type
                        "
                        target="_blank"
                      >
                        {{ news.title }}
                      </router-link>
                      <router-link
                        target="_blank"
                        v-else-if="canOpen('WPP_ESZLJP_GUIDE') === 'can_open'"
                        :to="{ path: '/ppp/viewAct/' + news.id }"
                      >
                        {{ news.title }}
                      </router-link>
                      <!-- <router-link target="_blank" v-if="canOpen('WPP_ESZLJP_GUIDE') === 'can_open'"
                                                        :to="{ path: '/ppp/viewAct/' + news.id }">{{
                                                            news.title
                                                        }}</router-link> -->
                      <a
                        v-if="canOpen('WPP_ESZLJP_GUIDE') === 'not_logged_in'"
                        v-b-modal.login-modal
                        href="#"
                        @click.stop.prevent
                      >
                        {{ news.title }}
                      </a>
                      <a
                        v-if="
                          canOpen('WPP_ESZLJP_GUIDE') === 'role_not_allowed'
                        "
                        href="#"
                        @click.stop.prevent="role_not_allowed()"
                      >
                        {{ news.title }}
                      </a>
                    </div>
                  </div>
                  <!--                                    search result begin-->
                  <div
                    v-if="q_response.resultMap.PP_ESZLJP_total"
                    class="search-sub-sec__footer"
                  >
                    <router-link
                      class="search-sub-sec__more-link d-flex align-items-center justify-content-between"
                      :to="{
                        path: '/pp-search/WPP_ESZLJP_GUIDE',
                        query: { q: $route.query.q },
                      }"
                    >
                      <span class="text">
                        Приказано {{ q_response.resultMap.PP_ESZLJP.length }} од
                        {{ q_response.resultMap.PP_ESZLJP_total }} резултата.
                        Види све резултате претраге
                      </span>
                      <div class="search-sub-sec__read-more">
                        <span class="icon-chevron-right"></span>
                        <span class="icon-chevron-right"></span>
                        <span class="icon-chevron-right"></span>
                      </div>
                    </router-link>
                  </div>
                  <!--                                    search result end -->
                </div>
              </div>
              <!-- ***************************************Krivicna dela u sudskoj praksi*****************************************************-->
              <div v-if="q_response.resultMap.PP_KD" class="col-6">
                <div class="search-sub-sec" :class="canOpen('WPP_KD')">
                  <div class="search-sub-sec__header">
                    <h3 class="search-sub-sec__title">
                      Кривична дела у судској пракси
                    </h3>
                  </div>
                  <div class="search-sub-sec__body">
                    <div
                      v-for="(news, index) in q_response.resultMap.PP_KD"
                      v-bind:key="index"
                      class="search-result__item "
                    >
                      <router-link
                        v-if="
                          canOpen('WPP_KD') === 'can_open' &&
                            news.act_type === 'REG' &&
                            news.has_html === 'False'
                        "
                        :to="
                          '/pppViewPdf/' +
                            news.reg_db_id +
                            '?doctype=' +
                            news.act_type
                        "
                        target="_blank"
                      >
                        {{ news.title }}
                      </router-link>
                      <router-link
                        v-else-if="
                          canOpen('WPP_KD') === 'can_open' &&
                            news.act_type === 'SLGLRS' &&
                            news.has_html === 'False'
                        "
                        :to="
                          '/pppViewPdf/' +
                            news.guid_pdf_url +
                            '?doctype=' +
                            news.act_type
                        "
                        target="_blank"
                      >
                        {{ news.title }}
                      </router-link>
                      <router-link
                        target="_blank"
                        v-else-if="canOpen('WPP_KD') === 'can_open'"
                        :to="{ path: '/ppp/viewAct/' + news.id }"
                      >
                        {{ news.title }}
                      </router-link>
                      <!-- <router-link target="_blank" v-if="canOpen('WPP_KD') === 'can_open'"
                                            :to="{ path: '/ppp/viewAct/' + news.id }">{{
                                                news.title
                                            }}</router-link> -->
                      <a
                        v-if="canOpen('WPP_KD') === 'not_logged_in'"
                        v-b-modal.login-modal
                        href="#"
                        @click.stop.prevent
                      >
                        {{ news.title }}
                      </a>
                      <a
                        v-if="canOpen('WPP_KD') === 'role_not_allowed'"
                        href="#"
                        @click.stop.prevent="role_not_allowed()"
                      >
                        {{ news.title }}
                      </a>
                    </div>
                  </div>
                  <!--                                    search result begin-->
                  <div
                    v-if="q_response.resultMap.PP_KD_total"
                    class="search-sub-sec__footer"
                  >
                    <router-link
                      class="search-sub-sec__more-link d-flex align-items-center justify-content-between"
                      :to="{
                        path: '/pp-search/WPP_KD',
                        query: { q: $route.query.q },
                      }"
                    >
                      <span class="text">
                        Приказано {{ q_response.resultMap.PP_KD.length }} од
                        {{ q_response.resultMap.PP_KD_total }} резултата. Види
                        све резултате претраге
                      </span>
                      <div class="search-sub-sec__read-more">
                        <span class="icon-chevron-right"></span>
                        <span class="icon-chevron-right"></span>
                        <span class="icon-chevron-right"></span>
                      </div>
                    </router-link>
                  </div>
                  <!--                                    search result end -->
                </div>
              </div>
              <!-- *********************************************Propisi gradova***********************************************-->
              <div v-if="q_response.resultMap.Regulations" class="col-md-6">
                <div class="search-sub-sec" :class="canOpen('BGP')">
                  <div class="search-sub-sec__header">
                    <h3 class="search-sub-sec__title">
                      Прописи града Београда
                    </h3>
                  </div>
                  <div class="search-sub-sec__body">
                    <div
                      v-for="(news, index) in q_response.resultMap.Regulations"
                      v-bind:key="index"
                      class="search-result__item "
                    >
                      <div v-if="news.uuid !== null && news.uuid !== ''">
                        <router-link
                          v-if="canOpen('BGP') === 'can_open'"
                          target="_blank"
                          :to="{ path: 'regulations/viewAct/' + news.uuid }"
                        >
                          <span class="text">{{ news.title }}</span>
                        </router-link>
                        <a
                          v-if="canOpen('BGP') === 'not_logged_in'"
                          v-b-modal.login-modal
                          href="#"
                          @click.stop.prevent
                        >
                          {{ news.title }}
                        </a>
                        <a
                          v-if="canOpen('BGP') === 'role_not_allowed'"
                          href="#"
                          @click.stop.prevent="role_not_allowed()"
                        >
                          {{ news.title }}
                        </a>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="q_response.resultMap.Regulations_total"
                    class="search-sub-sec__footer"
                  >
                    <router-link
                      class="search-sub-sec__more-link d-flex align-items-center justify-content-between"
                      :to="{
                        path: '/regulations-search',
                        query: { q: $route.query.q },
                      }"
                    >
                      <span class="text">
                        Приказано
                        {{ q_response.resultMap.Regulations.length }} од
                        {{ q_response.resultMap.Regulations_total }} резултата.
                        Види све резултате претраге
                      </span>
                      <div class="search-sub-sec__read-more">
                        <span class="icon-chevron-right"></span>
                        <span class="icon-chevron-right"></span>
                        <span class="icon-chevron-right"></span>
                      </div>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- ********************************************************************************************-->
          <div v-if="q_response.resultMap.PROPISI">
            <h3 class="search-sec__title can_open">
              Прописи на енглеском језику
            </h3>
            <div class="row">
              <div class="col-md-12">
                <div class="search-sub-sec can_open">
                  <div class="search-sub-sec__body">
                    <div
                      v-for="(news, index) in q_response.resultMap.PROPISI"
                      v-bind:key="index"
                      class="search-result__item "
                    >
                      <a
                        :href="baseEnUrl + 'content/' + news.id"
                        target="_blank"
                      >
                        {{ news.name }}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import HomeWelcomeSec from "@/components/HomeWelcomeSec.vue";

// import SearchSubSecComponent from '@/components/SearchSubSecComponent.vue';

export default {
  name: "UnifiedSearchPage",
  data() {
    return {
      query: null,
      q_response: null,
      baseApiUrl: window.env.VUE_APP_API_DI_DEV,
      baseREGApiUrl: window.env.VUE_APP_API_REG_DEV,
      baseSLGLApiUrl: window.env.VUE_APP_API_SLGL_DEV,
      baseSPApiUrl: window.env.VUE_APP_API_SP_DEV,
      baseMMLApiUrl: window.env.VUE_APP_API_MML_DEV,
      baseRegulationsApiUrl: window.env.VUE_APP_API_REGULATIONS_DEV,
      baseEnUrl: window.env.VUE_APP_EN_BASE_URL_PRODUCTION,
      // testBaseApiUrl: window.TEST_BASE_URL,
      meta: {
        title: "Правно-информациони систем РС",
        description:
          "Правно-информациони систем je збирка података у електронском облику која садржи: електронски облик Службеног гласника, архиву службених гласила, базу која садржи регистар и текстове важећих прописа и других аката Републике Србије објављених у Службеном гласнику, базу која садржи судску праксу, друге податке о правном систему Републике Србије и везу с правним актима Европске уније.",
        keywords:
          "zakoni, akti, zakonski, propisi, sudska praksa, registar, odluka, sudovi, ugovori, pravno informacioni sistem, prins, pis,sluzbeni glasnik",
      },
    };
  },
  metaInfo() {
    return {
      title: this.meta.title,
      meta: [
        { name: "title", content: this.meta.title },
        { name: "description", content: this.meta.description },
        { name: "keywords", content: this.meta.keywords },
      ],
    };
  },
  components: {
    HomeWelcomeSec,
    // SearchSubSecComponent
  },
  computed: {
    queryWord() {
      return this.$route.query.q;
    },
    ...mapState(["userInfoState"]),
    isSarchReseeted() {
      if (this.$route.query.q === "null") {
        return false;
      } else {
        return true;
      }
    },
    mmlCanOpen() {
      if (this.userInfoState) {
        if (this.userInfoState.roles.includes("LSD")) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },

    // canOpen() {
    //     if(this.userInfoState){
    //         if(this.userInfoState.roles.includes(this.code)){
    //             return  true;
    //         } else {
    //             return false;
    //         }
    //     } else{
    //         return false;
    //     }
    //
    //
    // }
  },
  watch: {
    $route() {
      // to, from
      this.query = this.$route.query.q;
      this.search();
    },
  },
  methods: {
    canOpen(code) {
      if (this.userInfoState) {
        if (this.userInfoState.roles.includes(code)) {
          return "can_open";
        } else {
          return "role_not_allowed";
        }
      } else {
        return "not_logged_in";
      }
    },
    role_not_allowed() {
      alert("Немате приступ овој бази");
    },
    buildLink(uuid) {
      axios
        .get(this.baseApiUrl + "api/reg/meta/byActUuid/" + uuid)
        .then((response) => {
          if (response.data.url !== undefined) {
            this.$router.push(response.data.url + "?q=" + uuid);
          } else this.$router.push("/reg/viewAct/" + uuid + "?q=" + uuid);
        });
    },
    searchResultReset(event) {
      this.q_response = event;
      this.queryWord = null;
    },
    search() {
      axios
        .post(this.baseApiUrl + "common/unifiedSearch", {
          tk: this.$route.query.q,
        })
        .then((response) => {
          console.log("search result", response);
          this.q_response = response.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    onReset(evt) {
      evt.preventDefault();
    },
  },
  mounted() {
    this.search();
    // q = res
  },
};
</script>

<style scoped></style>
